import {
  CLEAR_PROFILE,
  SET_PROFILE,
  UPDATE_EMAIL,
  UPDATE_PROFILE,
  CREATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  SEND_INVITES_AND_UPDATE_PROFILE,
  UPDATE_BANNER,
  REFRESH_PROFILE,
} from 'constants/constants';

export const clearProfile = () => ({
  type: CLEAR_PROFILE
});

export const setProfile = (user) => ({
  type: SET_PROFILE,
  payload: user
});

export const updateEmail = (password, newEmail) => ({
  type: UPDATE_EMAIL,
  payload: {
    password,
    newEmail
  }
});

export const createProfile = (newProfile) => ({
  type: CREATE_PROFILE,
  payload: {
    updates: newProfile.updates,
    files: newProfile.files,
    credentials: newProfile.credentials
  }
});

export const updateProfile = (newProfile) => ({
  type: UPDATE_PROFILE,
  payload: {
    updates: newProfile.updates,
    files: newProfile.files,
    credentials: newProfile.credentials
  }
});

export const updateBanner = (newProfile) => ({
  type: UPDATE_BANNER,
  payload: {
    updates: newProfile.updates
  }
});

export const sendInvites = (invitees) => ({
  type: SEND_INVITES_AND_UPDATE_PROFILE,
  payload: {
    updates: invitees
  }
});

export const updateProfileSuccess = (updates) => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: updates
});

export const refreshProfile = () => ({
  type: REFRESH_PROFILE,
});
